interface TabVNScript {
  name: string
  body: string[]
}

/**
 * Handles loading all scripts from the backend.
 */
export default {
  state: {
    scriptBuffer: {},
    src: '1MyX9CYXWFHsP_bynoKOUTDxkiyDtMV0MXnyc_CxN7Mk',
    initFile: 'INIT.PAPSYS!A2:C40',
    hasInit: false,
    api: null,
  },
  mutations: {
    _SCRIPTS_BUFFER_LOAD(state: any, payload: TabVNScript) {
      state.scriptBuffer[payload.name] = payload.body
    },
    _SCRIPTS_SET_GAPI(state: any, api: any) {
      state.api = api
    },
  },
  actions: {
    M_SCRIPT_LOAD(ctx: any, pl: any) {
      if (!ctx.state.api && !pl.api) { return Promise.reject('No API provided') }
      const url = `https://sheets.googleapis.com/v4/spreadsheets/${ctx.state.src}/values/${pl.fileName}`
      const api = pl.api || ctx.state.api
      return api.request(url)
        .then((result: any) => {
          const newBody: string[] = []
          const body = JSON.parse(result.body).values
            .forEach((row: any) => {
              newBody[parseInt(row[0])] = row.slice(1)
            })
          ctx.commit('_SCRIPTS_BUFFER_LOAD', { name: pl.fileName.split('!')[0], body: newBody })
          return newBody
        })
    },
    M_INIT(ctx: any, api: any) {
      return ctx.dispatch('M_SCRIPT_LOAD', { api, fileName: ctx.state.initFile })
        .then((results: any) => {
          ctx.state.hasInit = true
          return results
        })
    },
  },
}
